import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { LazyMarkdown } from '@sorare/core/src/atoms/markdown/LazyMarkdown';

import { DumbNotification } from 'components/activity/DumbNotification';

import { commonNotificationInterfaceFragment } from '../fragments';
import type { CommonNotificationProps } from '../types';
import type { MarketingNotification_marketingNotification } from './__generated__/index.graphql';

type Props = CommonNotificationProps & {
  notification: MarketingNotification_marketingNotification;
};

export const MarketingNotification = ({ notification, ...rest }: Props) => {
  const { createdAt, url, imageUrl, sport, read, name } = notification;

  if (imageUrl) {
    return (
      <DumbNotification
        title={<LazyMarkdown data={notification.markdownBody} />}
        link={url}
        createdAt={createdAt}
        sport={sport}
        read={read}
        avatarUrl={imageUrl}
        name={name}
        {...rest}
      />
    );
  }

  return (
    <DumbNotification
      title={<LazyMarkdown data={notification.markdownBody} />}
      link={url}
      createdAt={createdAt}
      sport={sport}
      read={read}
      name={name}
      {...rest}
    />
  );
};

MarketingNotification.fragments = {
  marketingNotification: gql`
    fragment MarketingNotification_marketingNotification on MarketingNotification {
      id
      ...Notification_notificationInterface
      imageUrl
      url
    }
    ${commonNotificationInterfaceFragment}
  ` as TypedDocumentNode<MarketingNotification_marketingNotification>,
};
